export default [
  {
    path: '',
    name: 'empresa.dashboard',
    component: () => import('@/views/empresa/dashboard/EmpresaDashboard.vue'),
  },
]